"use client";
import { ElProps } from "@/type"
import { cn } from "utils"
import { FC } from "react"
import { createRoot } from 'react-dom/client';
interface MessageProps extends ElProps {

}
const MessageComponent:FC<MessageProps> = ({className, children}) => {
  return (<div className={cn("rounded-lg p-4 text-sm backdrop-blur-2xl mt-4 message-animation max-w-[80vw]", className)}>
    {children}
  </div>)
}

export const message = ({className, content}: {className?: MessageProps['className'], content: MessageProps['children']}) => {
  const el = document.querySelector("#toast");
  if (!el) return;
  const conatiner = document.createElement('div');
  const root = createRoot(conatiner);
  root.render(
    <MessageComponent className={className}>{content}</MessageComponent>
  )
  el.appendChild(conatiner)
  setTimeout(() => {
    root.unmount()
  }, 6000)
}